/* eslint-disable */ 
import React, { useState ,useEffect} from "react";
import { Link } from "react-router-dom";
import { logo } from "../_components/Imagepath";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emailrgx } from "../assets/constant";
import axios from "axios";

import { useAuth } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Lang from "../common/Lang";
const VerificationNotifications = (props) => {

  const user = useAuth();
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <img
              className="img-fluid logo-dark mb-2"
              src={logo}
              alt="Logo"
            />
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>{t("Verify Your Account")}</h1>
                  <br></br>
                  <p className="text-center">
                    {t("Please check your email inbox and click on the verification link we sent to complete your account setup.")}
                  </p>
                  <p className="text-center">
                    {t("If you didn't receive the email, check your spam folder")}
                    {/* <a href="/resend-verification" class="btn">Resend Verification</a> */}
                  </p>
                  <br></br>
                  <p className="text-center"><strong>{t("Already clicked the verification link?")}</strong></p>
                  <p className="text-center">
                    {t("Great! You can now")} <a href="/login">{t("go to the login page")}</a> {t("and access your account.")}.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default VerificationNotifications;
